import { WEB_APPS_LIST_BY_NAME } from "../../modules/AppWrapper2/types.js";
// src/utils/URL-ops/make-ops-report-URL.ts
var OPS_REPORT_PATH = `${WEB_APPS_LIST_BY_NAME.OPS.link}/reports/view/:reportId`;
function makeOpsReportURL(reportId) {
	if (!reportId) console.warn("makeOpsReportURL: no reportId provided");
	return OPS_REPORT_PATH.replace(":reportId", reportId);
}
export { makeOpsReportURL };

//# sourceMappingURL=make-ops-report-URL.js.map